// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --addons-notification-font-size: var(
    --readthedocs-notification-font-size,
    var(--readthedocs-font-size, 1rem)
  );
}

:host > div {
  margin: 1rem 0rem;
  padding-top: var(--addons-notification-font-size);
  padding-bottom: var(--addons-notification-font-size);
  overflow: auto;
  border-radius: 0.5rem;
  font-family: var(
    --readthedocs-notification-font-family,
    "Lato",
    "proxima-nova",
    "Helvetica Neue",
    "Arial",
    "sans-serif"
  );
  font-size: var(--addons-notification-font-size);
  color: var(--readthedocs-notification-color, rgb(64, 64, 64));
  background-color: var(
    --readthedocs-notification-background-color,
    rgb(234, 234, 234)
  );
}

:host(.floating) > div {
  position: fixed;
  top: 2rem;
  left: 20%; /* (100 - width) / 2 */
  width: 60%;
  z-index: 1750;
}

:host(.toast) > div {
  position: fixed;
  padding-top: calc(var(--addons-notification-font-size) * 0.75);
  padding-bottom: calc(var(--addons-notification-font-size) * 0.75);
  margin: 0.75rem 0rem;
  top: 2rem;
  right: 2rem;
  z-index: 1750;
  font-size: var(
    --readthedocs-notification-toast-font-size,
    calc(var(--addons-notification-font-size) * 0.85)
  );
  width: 35rem;
  max-width: calc(100vw - 4rem);
}

@media (max-width: 640px) {
  :host(.toast) > div {
    right: 0.5rem;
  }

  :host(.floating) > div {
    width: 95%;
    left: 2%;
  }
}

:host(.raised) > div {
  box-shadow:
    0 2px 4px 0 rgba(34, 36, 38, 0.12),
    0 2px 10px 0 rgba(34, 36, 38, 0.15);
}

:host(.titled) > div {
  padding: 0rem;
  text-align: center;
}

:host > div > svg.header.icon {
  height: calc(var(--addons-notification-font-size) * 2);
  padding: 0.5rem 1.5rem;
  float: left;
}

:host(.toast) > div > svg.header.icon {
  height: calc(var(--addons-notification-font-size) * 1.5);
}

:host(.titled) > div > svg.header.icon {
  display: none;
}

:host(.inverted) > div {
  color: var(--readthedocs-notification-color, rgb(234, 234, 234));
  background-color: var(
    --readthedocs-notification-background-color,
    rgb(64, 64, 64)
  );
}

:host > div a {
  color: var(--readthedocs-notification-link-color, rgb(8, 140, 219));
  text-decoration: none;
}

:host(.inverted) > div a {
  color: var(--readthedocs-notification-link-color, rgb(134, 203, 243));
}

:host > div > .title {
  padding: 0.25rem var(--addons-notification-font-size);
  margin-bottom: 0.25rem;
  line-height: var(--addons-notification-font-size);
  font-weight: bold;
}
:host > div > div.content {
  line-height: var(--addons-notification-font-size);
  font-size: calc(var(--addons-notification-font-size) * 0.85);
  padding: 0 calc(var(--addons-notification-font-size) * 1.5);
}

:host(.toast) > div > .title {
  padding: 0rem var(--addons-notification-font-size);
}

:host(.titled) > div > .title {
  display: block;
  margin: 0rem;
  padding: 0.1rem var(--addons-notification-font-size);
  line-height: calc(var(--addons-notification-font-size) * 2);
  border-radius: 0.5rem 0.5rem 0 0;
  color: var(--readthedocs-notification-title-color, rgb(96, 96, 96));
  background-color: var(
    --readthedocs-notification-title-background-color,
    rgb(224, 224, 224)
  );
  vertical-align: middle;
  font-weight: bold;
}
:host(.titled) > div > div.content {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0rem 0.65rem 0rem 0.65rem;
}

:host(.inverted) > div > .title {
  color: var(--readthedocs-notification-title-color, rgba(255, 255, 255, 0.9));
}

:host(.inverted.titled) > div > .title {
  background-color: var(
    --readthedocs-notification-title-background-color,
    rgb(48, 48, 48)
  );
}

:host > div > .title > .right {
  float: right;
}

:host > div > .title > .right > svg {
  display: inline-block;
  height: var(--addons-notification-font-size);
  vertical-align: middle;
  cursor: pointer;
  color: var(--readthedocs-notification-title-color, rgba(96, 96, 96));
  font-weight: normal;
}

:host(.inverted) > div > .title > .right > svg {
  color: var(--readthedocs-notification-title-color, rgba(255, 255, 255, 0.9));
}
:host(.titled) > div > .title > .right > svg {
  margin: 0.5rem 0rem;
}
`, "",{"version":3,"sources":["webpack://./src/notification.css"],"names":[],"mappings":"AAAA;EACE;;;GAGC;AACH;;AAEA;EACE,iBAAiB;EACjB,iDAAiD;EACjD,oDAAoD;EACpD,cAAc;EACd,qBAAqB;EACrB;;;;;;;GAOC;EACD,+CAA+C;EAC/C,6DAA6D;EAC7D;;;GAGC;AACH;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS,EAAE,sBAAsB;EACjC,UAAU;EACV,aAAa;AACf;;AAEA;EACE,eAAe;EACf,8DAA8D;EAC9D,iEAAiE;EACjE,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,aAAa;EACb;;;GAGC;EACD,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;AACF;;AAEA;EACE;;uCAEqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gEAAgE;EAChE;;;GAGC;AACH;;AAEA;EACE,mEAAmE;EACnE,qBAAqB;AACvB;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,qDAAqD;EACrD,sBAAsB;EACtB,iDAAiD;EACjD,iBAAiB;AACnB;AACA;EACE,iDAAiD;EACjD,4DAA4D;EAC5D,2DAA2D;AAC7D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oDAAoD;EACpD,2DAA2D;EAC3D,gCAAgC;EAChC,mEAAmE;EACnE;;;GAGC;EACD,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE;;;GAGC;AACH;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,sBAAsB;EACtB,eAAe;EACf,oEAAoE;EACpE,mBAAmB;AACrB;;AAEA;EACE,4EAA4E;AAC9E;AACA;EACE,mBAAmB;AACrB","sourcesContent":[":host {\n  --addons-notification-font-size: var(\n    --readthedocs-notification-font-size,\n    var(--readthedocs-font-size, 1rem)\n  );\n}\n\n:host > div {\n  margin: 1rem 0rem;\n  padding-top: var(--addons-notification-font-size);\n  padding-bottom: var(--addons-notification-font-size);\n  overflow: auto;\n  border-radius: 0.5rem;\n  font-family: var(\n    --readthedocs-notification-font-family,\n    \"Lato\",\n    \"proxima-nova\",\n    \"Helvetica Neue\",\n    \"Arial\",\n    \"sans-serif\"\n  );\n  font-size: var(--addons-notification-font-size);\n  color: var(--readthedocs-notification-color, rgb(64, 64, 64));\n  background-color: var(\n    --readthedocs-notification-background-color,\n    rgb(234, 234, 234)\n  );\n}\n\n:host(.floating) > div {\n  position: fixed;\n  top: 2rem;\n  left: 20%; /* (100 - width) / 2 */\n  width: 60%;\n  z-index: 1750;\n}\n\n:host(.toast) > div {\n  position: fixed;\n  padding-top: calc(var(--addons-notification-font-size) * 0.75);\n  padding-bottom: calc(var(--addons-notification-font-size) * 0.75);\n  margin: 0.75rem 0rem;\n  top: 2rem;\n  right: 2rem;\n  z-index: 1750;\n  font-size: var(\n    --readthedocs-notification-toast-font-size,\n    calc(var(--addons-notification-font-size) * 0.85)\n  );\n  width: 35rem;\n  max-width: calc(100vw - 4rem);\n}\n\n@media (max-width: 640px) {\n  :host(.toast) > div {\n    right: 0.5rem;\n  }\n\n  :host(.floating) > div {\n    width: 95%;\n    left: 2%;\n  }\n}\n\n:host(.raised) > div {\n  box-shadow:\n    0 2px 4px 0 rgba(34, 36, 38, 0.12),\n    0 2px 10px 0 rgba(34, 36, 38, 0.15);\n}\n\n:host(.titled) > div {\n  padding: 0rem;\n  text-align: center;\n}\n\n:host > div > svg.header.icon {\n  height: calc(var(--addons-notification-font-size) * 2);\n  padding: 0.5rem 1.5rem;\n  float: left;\n}\n\n:host(.toast) > div > svg.header.icon {\n  height: calc(var(--addons-notification-font-size) * 1.5);\n}\n\n:host(.titled) > div > svg.header.icon {\n  display: none;\n}\n\n:host(.inverted) > div {\n  color: var(--readthedocs-notification-color, rgb(234, 234, 234));\n  background-color: var(\n    --readthedocs-notification-background-color,\n    rgb(64, 64, 64)\n  );\n}\n\n:host > div a {\n  color: var(--readthedocs-notification-link-color, rgb(8, 140, 219));\n  text-decoration: none;\n}\n\n:host(.inverted) > div a {\n  color: var(--readthedocs-notification-link-color, rgb(134, 203, 243));\n}\n\n:host > div > .title {\n  padding: 0.25rem var(--addons-notification-font-size);\n  margin-bottom: 0.25rem;\n  line-height: var(--addons-notification-font-size);\n  font-weight: bold;\n}\n:host > div > div.content {\n  line-height: var(--addons-notification-font-size);\n  font-size: calc(var(--addons-notification-font-size) * 0.85);\n  padding: 0 calc(var(--addons-notification-font-size) * 1.5);\n}\n\n:host(.toast) > div > .title {\n  padding: 0rem var(--addons-notification-font-size);\n}\n\n:host(.titled) > div > .title {\n  display: block;\n  margin: 0rem;\n  padding: 0.1rem var(--addons-notification-font-size);\n  line-height: calc(var(--addons-notification-font-size) * 2);\n  border-radius: 0.5rem 0.5rem 0 0;\n  color: var(--readthedocs-notification-title-color, rgb(96, 96, 96));\n  background-color: var(\n    --readthedocs-notification-title-background-color,\n    rgb(224, 224, 224)\n  );\n  vertical-align: middle;\n  font-weight: bold;\n}\n:host(.titled) > div > div.content {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding: 0rem 0.65rem 0rem 0.65rem;\n}\n\n:host(.inverted) > div > .title {\n  color: var(--readthedocs-notification-title-color, rgba(255, 255, 255, 0.9));\n}\n\n:host(.inverted.titled) > div > .title {\n  background-color: var(\n    --readthedocs-notification-title-background-color,\n    rgb(48, 48, 48)\n  );\n}\n\n:host > div > .title > .right {\n  float: right;\n}\n\n:host > div > .title > .right > svg {\n  display: inline-block;\n  height: var(--addons-notification-font-size);\n  vertical-align: middle;\n  cursor: pointer;\n  color: var(--readthedocs-notification-title-color, rgba(96, 96, 96));\n  font-weight: normal;\n}\n\n:host(.inverted) > div > .title > .right > svg {\n  color: var(--readthedocs-notification-title-color, rgba(255, 255, 255, 0.9));\n}\n:host(.titled) > div > .title > .right > svg {\n  margin: 0.5rem 0rem;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
